/**
 * ユーザーを 1 人選ぶ Select(ID管理の画面で共通に使う)。
 *
 * **打った文字はサーバーへ渡す**(`filterOption={false}`)。
 * 「先頭 N 件を取って手元で絞る」にすると、母数が N を超えた瞬間に
 * 今作ったばかりの人が候補に出なくなる(2026-09-27 の実測)。
 *
 * `Form.Item` の中に置けば value / onChange は antd が入れてくれる。
 */
import { Select } from "antd";
import { useState } from "react";

import { useDebounced } from "../../lib/useDebounced";
import { useIdpUsers } from "./hooks";

/** 候補として引く件数。絞り込みはサーバーがやるので多く取る必要はない。 */
const LIMIT = 20;

export function UserPicker({
  value,
  onChange,
  disabled,
  placeholder = "ユーザー名・氏名・メールで探す",
  allowClear = false,
  style,
}: {
  value?: string;
  onChange?: (v: string | undefined) => void;
  disabled?: boolean;
  placeholder?: string;
  allowClear?: boolean;
  style?: React.CSSProperties;
}) {
  const [typed, setTyped] = useState("");
  const q = useDebounced(typed);
  const users = useIdpUsers({ q, limit: LIMIT, offset: 0 });

  return (
    <Select
      showSearch
      // サーバーが絞った候補をそのまま出す(手元で絞らない)
      filterOption={false}
      allowClear={allowClear}
      disabled={disabled}
      placeholder={placeholder}
      style={style ?? { width: "100%" }}
      value={value}
      loading={users.isFetching}
      onSearch={setTyped}
      onChange={(v?: string) => onChange?.(v ?? undefined)}
      notFoundContent={users.isFetching ? "探している…" : "見つからない"}
      options={(users.data?.items ?? []).map((u) => ({
        value: u.id,
        label: u.displayName ? `${u.username}(${u.displayName})` : u.username,
      }))}
    />
  );
}
